import releaseNotesContent from './release-notes.json';
import { IReleaseNotesContent } from '../interfaces/i-release-notes';

/**
 * Notas de versão exibidas no modal de novidades. Para publicar uma release
 * basta acrescentar um objeto no **topo** do array `versoes` do
 * `release-notes.json` — a tipagem abaixo garante que o arquivo continue
 * seguindo o contrato de `IReleaseNotesContent`.
 *
 * O array precisa estar em ordem decrescente de versão: a primeira posição é
 * tratada como a versão atual do sistema (`currentVersion`), que é o valor
 * comparado com o `ultimaVersaoNotasVista` de cada usuário para decidir se o
 * modal reaparece.
 *
 * Ao publicar uma versão nova, espelhe o mesmo número no `version` dos dois
 * `package.json` (frontend e API). Esse espelho é apenas documental — quem
 * manda em tempo de execução é este JSON.
 */
const content: IReleaseNotesContent =
  releaseNotesContent as IReleaseNotesContent;

export const releaseVersions = content.versoes || [];

export const currentVersion = releaseVersions[0]?.versao || '';
